import { UserPlusIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedMatterClientCreatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface MatterClientCreatedEventProps {
  event: DiscriminatedMatterClientCreatedEvent;
}

export const MatterClientCreatedEvent: React.FC<
  MatterClientCreatedEventProps
> = ({ event }) => {
  const { matter_client } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-green-100">
          <UserPlusIcon className="h-4 w-4 text-green-600" />
        </div>
      }
    />
  );

  const clientName = matter_client.name;

  const body = (
    <ActivityBody>
      {clientName && <ActivityTitle>{clientName}</ActivityTitle>}
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Client Added"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
